var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoreOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00AECB",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 10,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 17.5,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreOption);
export default __webpack_public_path__ + "static/media/icon-more-option.a7bb6d7d190fb56969cf4b4111189713.svg";
export { ForwardRef as ReactComponent };